// extracted by mini-css-extract-plugin
export default {"links":"erJUrYmF_mwcSnH0eS3q"};